import {
  HOME_SERVICE_LINK_CLICK,
  MOBILE_SERVICES_HOMEPAGE,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export default async () => {
  const { isEnabled } = getExperimentOnClient(MOBILE_SERVICES_HOMEPAGE) || {}

  if (isEnabled) {
    await activateExperiment(MOBILE_SERVICES_HOMEPAGE)

    const serviceLinksContainer = <HTMLElement>(
      document.querySelector('.o-ServiceLinksContainer')
    )

    if (serviceLinksContainer) {
      serviceLinksContainer.addEventListener('click', (e: MouseEvent) => {
        const target = <HTMLElement>e.target

        if (target.closest('.o-IconLinksList__item')) {
          trackOptimizelyEvent(HOME_SERVICE_LINK_CLICK)
        }
      })
    }
  }
}
